import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { generateUserInfo } from './generateUserInfo.js';
import { getCookie } from './getCookie.js';
import { setCookie } from './setCookie.js';

var USER_INFO_EXPIRATION = 365 * 2 * 24 * 60 * 60 * 1000;
var USER_INFO_COOKIE_KEY = 'fusra_user_info';
function getUserInfo() {
  var userInfoFromCookie = getCookie(USER_INFO_COOKIE_KEY);
  if (!userInfoFromCookie) {
    var userInfo = generateUserInfo();
    setCookie(USER_INFO_COOKIE_KEY, "".concat(userInfo.deviceId, "/").concat(userInfo.os, "/").concat(userInfo.creationDate), USER_INFO_EXPIRATION);
    return userInfo;
  }
  setCookie(USER_INFO_COOKIE_KEY, userInfoFromCookie, USER_INFO_EXPIRATION);
  var _userInfoFromCookie$s = userInfoFromCookie.split('/'),
    _userInfoFromCookie$s2 = _slicedToArray(_userInfoFromCookie$s, 3),
    deviceId = _userInfoFromCookie$s2[0],
    os = _userInfoFromCookie$s2[1],
    creationDate = _userInfoFromCookie$s2[2];
  return {
    deviceId: deviceId,
    os: os,
    creationDate: creationDate
  };
}

export { getUserInfo };
